<template>
  <h1
    v-if="tag === 'h1'"
    id="main-heading"
    class="title title--level-1"
    tabindex="-1"
  >
    <slot/>
  </h1>

  <h2
    v-else-if="tag === 'h2'"
    class="title title--level-2"
  >
    <slot/>
  </h2>

  <h3
    v-else-if="tag === 'h3'"
    class="title title--level-3"
  >
    <slot/>
  </h3>

  <legend
    v-else-if="tag === 'legend'"
    class="title title--level-2 title--legend"
  >
    <slot/>
  </legend>
</template>

<script>
export default {
  name: 'CTitle',

  props: {
    tag: {
      type: String,
      default: 'h1',
      validator (value) {
        return [
          'h1',
          'h2',
          'h3',
          'legend'
        ].indexOf(value) >= 0
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 700;
  line-height: 1.6;
}

.title--level-1,
.title--level-2 {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.title--level-1 {
  display: inline;
  margin: 0;

  font-size: calc(16px + 1vmin);

  border-bottom: 2px solid currentColor;
  outline: 0;
}

.title--level-1::after {
  content: "";

  display: block;
  margin-bottom: 1em;
}

.title--level-2 {
  margin: 1em 0 0.5em;
  font-size: calc(16px + 0.3vmin);
}

.title--level-3 {
  margin: 1em 0 0.5em;
  font-size: calc(16px + 0.2vmin);
}
</style>
